import { useState, useContext, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const { login, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const role = user?.role;

  // Якщо користувач вже авторизований (у т.ч. після мовчазного відновлення
  // сесії), перекидаємо його
  useEffect(() => {
    if (user) {
      navigate(role === "zppgy" ? "/propese-add" : "/");
    }
  }, [user, role, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null); 
    try {
      const role = await login(username, password);

      if (role === "admin") {
        navigate("/"); 
      } else if (role === "zppgy") {
        navigate("/propese-add"); //  zppgy -> на /propese-add
      } else {
        navigate("/");
      }
    } catch (error) {
      setError(error.message || "Помилка входу"); 
    }
  };

  return (
    <div className="mainContainer">
      <form onSubmit={handleLogin} className="loginBox">
        <h2 className="loginTitle">Вхід</h2>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <p className="loginLabel">Логін</p>
        <input
          className="loginInput"
          type="text"
          placeholder="Введіть ваш логін"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <p className="loginLabel">Пароль</p>
        <input
          className="loginInput"
          type="password"
          placeholder="Введіть ваш пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="loginSubmit">
          Увійти
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
